import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { UPDATE_DOCUMENTS_STATUS_MUTATION } from '../../../../pages/Accounts/DocumentManagement/services/document-management.service';
import { DECLINED_DOCUMENTS_QUERY } from '../../services/dashboard.service';
import ImportantDocumentsDeclineConfirmation from './ImportantDocumentsDeclineConfirmation';
import UserTermsOfUseDeclineConfirmation from './UserTermsOfUseDeclineConfirmation';

const DEFAULT_STATE = {
  declinedDocumentChangeAcceptanceRequests: [],
  isOwner: false,
};

const DeclinedDocuments = () => {
  const [declinedDocuments, setDeclinedDocuments] = useState(DEFAULT_STATE);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [updateDocumentChangeAcceptanceRequestsStatuses] = useMutation(UPDATE_DOCUMENTS_STATUS_MUTATION);
  const { error, data } = useQuery(DECLINED_DOCUMENTS_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!!data && !!data.declinedDocuments) {
      setDeclinedDocuments(data.declinedDocuments);
    }
    // eslint-disable-next-line
  }, [data]);

  if (error) {
    growlErrors(growl, error);
  }

  const updateStatuses = async (inputTypes, callback) => {
    try {
      await updateDocumentChangeAcceptanceRequestsStatuses({
        variables: {
          input: {
            accountId: currentAccount,
            inputTypes,
          },
        },
      });

      callback();
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  const hideDialog = () => setDeclinedDocuments(DEFAULT_STATE);

  const accept = () => {
    const inputTypes = declinedDocuments.declinedDocumentChangeAcceptanceRequests.map((declinedChangedRequest) => {
      return {
        id: declinedChangedRequest.id,
        documentId: declinedChangedRequest.documentId,
        documentType: declinedChangedRequest.documentType,
        status: 'ACCEPTED',
      };
    });

    updateStatuses(inputTypes, hideDialog);
  };

  if (declinedDocuments.isOwner) {
    return (
      <ImportantDocumentsDeclineConfirmation
        importantDeclinedDocuments={declinedDocuments}
        accept={accept}
        continueWithoutDeclining={hideDialog}
      />
    );
  }

  return (
    <UserTermsOfUseDeclineConfirmation
      visible={declinedDocuments !== DEFAULT_STATE}
      continueWithoutDeclining={hideDialog}
      accept={accept}
    />
  );
};

export default DeclinedDocuments;
